<template>
    <div class="menu w1200">

        <img @click="gotoHome" src="@/assets/login/logo3.png" alt="">

        <div class="list sky">
            <span v-for="(item, index) in menu" :key="index" @click="gotoRouter(item, index)"
                :class="{ active: vuex_menuActiveIndex === index }">
                {{ item.name }}
                <span v-if="item.status === 'jsz'" class="jsz">
                    正在建设中...
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // menuActive: 0,
            menu: [
                { name: "首页", url: '/home' },
                { name: "缩水单大厅", url: '/ssddt' },
                // { name: "缩水单冠王", url: '/ssdgw' },
                // { name: "十大缩水学霸", url: '/sdssxb' },
                { name: "缩水条件大厅", url: '/excel' },
                { name: "海选万元实战单", url: '/hxwysz' },
                { name: "缩水软件特区", url: '/suoshuiruanjian', },
                // { name: "实体投注站帮扶中心", url: '/sttzzbfzx', status: 'jsz' },
                { name: "实体投注站帮扶中心", url: '/sttzzbfzx' },
                { name: "彩运论坛", url: 'http://bbs.36886.net/' },
                { name: "帮助中心", url: '/personalCenter/help/help' },
            ],
        };
    },
    methods: {
        gotoHome() {
            this.$router.replace('/home');
            this.$vuex('vuex_menuActiveIndex', 0)
        },
        gotoRouter(item, index) {
            this.$vuex('vuex_menuActiveIndex', index)

            if (item.name == '彩运论坛') {
                window.open(item.url)
                return
            }
            // if (['实体投注站帮扶中心'].includes(item.name)) {
            //     this.$alert('敬请期待...', '提示', {
            //         type: 'warning',
            //         closeOnClickModal: true,
            //         confirmButtonText: '确定',
            //     });
            //     return
            // }
            this.$router.replace(item.url);
            this.menuActive = index
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/commonStyle.scss";

.menu {
    margin: 30px auto;
    display: flex;
    align-items: flex-start;
    background-color: $theme_color;
    height: 60px;
    overflow: hidden;

    >img {
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        transform: scale(1.16);
        transform-origin: right;
        cursor: pointer;
    }

    .list {
        font-weight: bold;

        >span {
            min-width: 100px;
            padding: 0 10px;
            text-align: center;
            color: #fff;
            display: inline-block;
            cursor: pointer;
            position: relative;
            height: 60px;
            line-height: 60px;

            .jsz {
                position: absolute;
                font-size: 12px;
                left: 0;
                width: 100%;
                color: blanchedalmond;
                top: 20px;
            }

            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }

            &.active {
                // color: #FF0000;
                background-color: rgba(0, 0, 0, 0.2);
            }
        }
    }
}

/* ===== 移动端适配 ===== */
@media (max-width: 768px) {
    .menu {
        height: auto;
        min-height: 60px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;

        .list > span {
            min-width: 78px;
            padding: 0 8px;
            font-size: 14px;
            white-space: nowrap;
        }
    }
}
</style>
